import { render } from "./AddCaregiverPage.vue?vue&type=template&id=b0dff19e&ts=true"
import script from "./AddCaregiverPage.vue?vue&type=script&lang=ts"
export * from "./AddCaregiverPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/Caregivers/AddCaregiverPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0dff19e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0dff19e', __exports__)) {
    api.reload('b0dff19e', __exports__)
  }
  
  module.hot.accept("./AddCaregiverPage.vue?vue&type=template&id=b0dff19e&ts=true", () => {
    api.rerender('b0dff19e', render)
  })

}


export default __exports__